import { useEffect, useState } from 'react';
import type { HealthCheckResponse } from '@driverforce/shared-types';
import { api } from '../services/api';
import { toastApiError, toastUnexpected } from '../lib/apiToast';

export const DashboardPage: React.FC = () => {
  const [health, setHealth] = useState<HealthCheckResponse | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .healthCheck()
      .then((response) => {
        if (response.success && response.data) {
          setHealth(response.data);
        } else {
          toastApiError(response, 'Failed to load system health');
        }
        setLoading(false);
      })
      .catch((err) => {
        toastUnexpected(err, 'Failed to load system health');
        setLoading(false);
      });
  }, []);

  const stats = [
    { name: 'Total Users', value: '0' },
    { name: 'Active Sessions', value: '0' },
    { name: 'API Status', value: health?.status === 'ok' ? 'Online' : 'Offline' },
    { name: 'Database', value: health?.services.database === 'ok' ? 'Connected' : 'Disconnected' },
  ];

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {stats.map((stat) => (
          <div key={stat.name} className="bg-white rounded-lg shadow p-6">
            <p className="text-sm font-medium text-gray-500">{stat.name}</p>
            <p className="text-2xl font-semibold text-gray-900 mt-1">
              {loading ? '...' : stat.value}
            </p>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">System Information</h3>
        {health && (
          <dl className="grid grid-cols-2 gap-4">
            <div>
              <dt className="text-sm font-medium text-gray-500">Version</dt>
              <dd className="text-sm text-gray-900">{health.version}</dd>
            </div>
            <div>
              <dt className="text-sm font-medium text-gray-500">Last Check</dt>
              <dd className="text-sm text-gray-900">{health.timestamp}</dd>
            </div>
            <div>
              <dt className="text-sm font-medium text-gray-500">Keycloak Status</dt>
              <dd className="text-sm text-gray-900">
                {health.services.keycloak === 'ok' ? 'Connected' : 'Disconnected'}
              </dd>
            </div>
          </dl>
        )}
      </div>
    </div>
  );
};
